<template>
	<el-dialog title="角色可下载项" :visible.sync="dialogVisible" width="1000px" top="3%" :close-on-click-modal="false"
		@close="closeDialog">
		<div style="text-align: right;">
			<el-button @click="chekcALL" size="mini" >全选</el-button>
		</div>
		<el-tree :check-on-click-node="true" ref="authTree" :props=" {children: 'children',label: 'col_name'}"
			node-key="id" :data="DataList" :default-expand-all="true" show-checkbox>

		</el-tree>

		<div style="text-align: right; padding: 10px; margin-top: 10px; border-top: 1px solid #ccc;">
			<el-button type="primary" icon="el-icon-s-claim" size="small" @click="saveAuthMenu">保存</el-button>
		</div>


	</el-dialog>

</template>

<script>
	export default {
		props: ['role_id'],
		data() {
			return {
				dialogVisible: true,
				DataList: [],
				checkedIds: []
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			getList() {
				this.$http.post("/api/sys_role_down_item_list").then(res => {
					this.DataList = res.data
					this.$http.post("/api/get_sys_role_down_item", {
						role_id: this.role_id
					}).then(res2 => {
						let kys = res2.data.map(e => {
							return e.id
						})

						this.$nextTick(() => {
							this.$refs["authTree"].setCheckedKeys(kys)

						})

					})
				})
			},
			saveAuthMenu() {
				let menus = this.$refs["authTree"].getCheckedNodes(false, true).map(e => {
					return e.id
				}).join(",")

				this.$http.post("/api/set_sys_role_down_item", {
					role_id: this.role_id,
					item_ids: menus
				}).then(res => {
					this.$message.success("保存成功")
					this.closeDialog()
				})
			},
			closeDialog() {
				this.dialogVisible = false
				setTimeout(() => {
					this.$parent.showRoleDitem = false
				}, 300)

			},
			chekcALL() {
				this.$refs["authTree"].setCheckedKeys(this.DataList.map(e => {
					return e.id
				}))
			}

		},
	}
</script>

<style>
</style>
